import { ParserAbstraction } from "./parser.abstraction";
import { ParserFunctionType } from "../parser.type";
import { SymbolStoreModel } from "@bitwarden/web-vault/app/models/store/symbol.store.model";

export class SymbolParser extends ParserAbstraction {
  override getParser(version: number): ParserFunctionType {
    if (!this.isSupportedVersion(version)) {
      throw new Error(`Unsupported Symbol parser version ${version}`);
    }

    if (version === 0) {
      return SymbolParser_v0;
    } else {
      return SymbolParser_v1;
    }
  }

  override getSupportedVersion(): number[] {
    return [0, 1];
  }
}

// v0 -> v1 added the optional `grp` (asset group) field - no data transform needed,
// absent `grp` is handled by SymbolView.fromStoreModel()'s defaultGroupForCode() fallback.
const SymbolParser_v1 = (symbol: any): any => symbol as SymbolStoreModel;

const SymbolParser_v0 = (symbol: any): any => SymbolParser_v1(symbol);
